import type { Restaurant } from "../../Manager/restaurant.types";
import { getOpenStatus } from "../SingleRest/OpeningHours";


export interface TempFilters {
  rating?: string;       // "Any", "4+", "3+"
  priceRange?: string[]; // ["$", "$$", "$$$", "$$$$"]
  openNow?: boolean;
  cuisines?: string[];
  mealType?: string[];
  experience?: string[];
}

/**
 * Compute a boost score for a restaurant based on selected filters.
 */
export function getBoostScore(restaurant: Restaurant, filters: TempFilters): number {
  let score = 0;
  const metadataRating = typeof restaurant.googleMetadata?.rating === 'number'
    ? restaurant.googleMetadata.rating
    : null;
  const overallRating = metadataRating ?? restaurant.rating?.average ?? 0;

  // ⭐ Rating boost
  if (filters.rating && filters.rating !== "Any") {
    const minRating = Number(filters.rating.replace("+", ""));
    if (overallRating >= minRating) {
      score += 10; 
    }
  }

  // 💰 Price/ Budget boost
  if (filters.priceRange && filters.priceRange.length > 0) {
    if (filters.priceRange.includes(restaurant.budgetLevel)) {
      score += 5;
    }
  }

  // 🟢 Open now boost
  if (filters.openNow) {
    const isOpen = restaurant.openingHours
      ? getOpenStatus(restaurant.openingHours).toLowerCase().startsWith("open")
      : false;
    if (isOpen) score += 3;
  }

  // 🍽️ Cuisine boost
  if (filters.cuisines && filters.cuisines.length > 0) {
    const matchCount = restaurant.cuisine.filter(c => filters.cuisines?.includes(c)).length;
    score += matchCount * 2;
  }

  // 🥘 Meal type boost
  if (filters.mealType && filters.mealType.length > 0) {
    const matchCount = restaurant.typeOfFood.filter(m => filters.mealType?.includes(m)).length;
    score += matchCount * 1;
  }

  // 🎭 Experience boost
  if (filters.experience && filters.experience.length > 0) {
    const matchCount = restaurant.experience.filter(e => filters.experience?.includes(e)).length;
    score += matchCount * 2;
  }

  // More boosts can be added here (tags, viewCount, recency, etc.)

  return score;
}
